import React, { Fragment, ReactElement } from 'react';
import TableRow from '../../../components/table-row/table-row.component';
import TableCell from '../../../components/table-cell/table-cell.component';
import Checkbox from '../../../components/checkbox/checkbox.component';
import LongClickTableRow from '../../../components/long-click-table-row/long-click-table-row.component';
import FilteredCell from '../../../components/filtered-cell/filtered-cell.component';
import ActivityRowForm from '../activity-row-form/activity-row-form.component';
import useScreenSmall from '../../../hooks/use-screen-small';

const ActivityRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_CHECKBOX_EXPORT: string = 'checkbox-export';

  const {
    isActive,
    isSaving,
    isSaveDisabled,
    isSelected,
    isInlineSaving,
    isEditMode,
    isSelectMode,
    isExportMode,
    isCustomizeMode,
    isDealActivity,
    category,
    activityItem,
    activityIndex,
    currentUser,
    inputRefs,
    tableName,
    tableColumnSettings,
    tableActivityListFields,
    activityCategoryIconMap,
    dealId,
    tagList,
    dealList,
    activityTypeList,
    activityStatusList,
    activityCategoryList,
    activityInterestLevelList,
    contactList,
    contactCompanyList,
    contactPersonList,
    contactPersonInternalList,
    measureUnitList,
    onRowClick,
    onLongClick,
    onInlineSave,
    onInlineCancel,
    onTagsChange,
    onDealContactsChange,
    onActivityDealSearch,
    onActivityDealSearchClose,
    onContactSearch,
    onContactSearchClose,
    onContactPersonSearch,
    onContactPersonSearchClose,
    onContactPersonInternalSearch,
    onContactPersonInternalSearchClose,
    onContactCompanySearch,
    onContactCompanySearchClose,
    onTagSearch,
    onTagSearchClose,
  } = props;

  const isSmallScreen: boolean = useScreenSmall();

  return (
    isEditMode && isActive ? (
      <ActivityRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        isDealActivity={isDealActivity}
        category={category}
        inputRefs={inputRefs}
        currentUser={currentUser}
        dealId={dealId}
        tableName={tableName}
        tableColumnSettings={tableColumnSettings}
        activityData={activityItem}
        activityIndex={activityIndex}
        activityStatusList={activityStatusList}
        activityCategoryList={activityCategoryList}
        activityCategoryIconMap={activityCategoryIconMap}
        dealList={dealList}
        contactList={contactList}
        contactCompanyList={contactCompanyList}
        contactPersonList={contactPersonList}
        contactPersonInternalList={contactPersonInternalList}
        measureUnitList={measureUnitList}
        activityTypeList={activityTypeList}
        activityInterestLevelList={activityInterestLevelList}
        tagList={tagList}
        onTagsChange={onTagsChange}
        onDealContactsChange={onDealContactsChange}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
        onActivityDealSearch={onActivityDealSearch}
        onActivityDealSearchClose={onActivityDealSearchClose}
        onContactSearch={onContactSearch}
        onContactSearchClose={onContactSearchClose}
        onContactPersonSearch={onContactPersonSearch}
        onContactPersonSearchClose={onContactPersonSearchClose}
        onContactPersonInternalSearch={onContactPersonInternalSearch}
        onContactPersonInternalSearchClose={onContactPersonInternalSearchClose}
        onContactCompanySearch={onContactCompanySearch}
        onContactCompanySearchClose={onContactCompanySearchClose}
        onTagSearch={onTagSearch}
        onTagSearchClose={onTagSearchClose}
      />
    ) : (
      <LongClickTableRow
        isActive={isSelected}
        isButton={!isCustomizeMode}
        component={TableRow}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onRowClick(event, activityItem.id);
        }}
        onLongClick={(): void => {
          onLongClick(activityItem.id);
        }}
      >
        {
          (isExportMode || isSelectMode) && (
            <TableCell isSticky isStickyLeft>
              <Checkbox
                isChecked={isSelected}
                withNoPadding={!isSmallScreen}
                id={`${ID_PREFIX_CHECKBOX_EXPORT}-${activityItem.id}`}
              />
            </TableCell>
          )
        }
        {
          tableActivityListFields.map((tableField: TableField): ReactElement | boolean => (
            !!tableField.component && (
              !tableField.isNotFiltered ? (
                <FilteredCell
                  key={tableField.id}
                  tableName={tableName}
                  columnName={tableField.name}
                  currentUser={currentUser}
                >
                  {tableField.component(activityItem)}
                </FilteredCell>
              ) : (
                <Fragment key={tableField.id}>
                  {tableField.component(activityItem)}
                </Fragment>
              )
            )
          ))
        }
      </LongClickTableRow>
    )
  );
});

export default ActivityRow;
